import { render, staticRenderFns } from "./DashboardImagePickerPage.vue?vue&type=template&id=236e1e53&"
import script from "./DashboardImagePickerPage.vue?vue&type=script&lang=js&"
export * from "./DashboardImagePickerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports